export interface RemoveQueryParamFromURLParams {
  queryParamName: string;
}

export const removeQueryParamsFromURL = ({
  queryParamName,
}: RemoveQueryParamFromURLParams) => {
  const url = new URL(window.location.href);

  url.searchParams.delete(queryParamName);

  // using history api to prevent page refreshing
  window.history.pushState({}, document.title, url);
};
